import { Component, OnInit, ChangeDetectorRef, HostListener, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { map, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Title, Meta } from '@angular/platform-browser';
import { ModalChooseRepositoryComponent } from './modal-choose-repository/modal-choose-repository.component';
import { ModalTreeCategoryComponent } from './modal-tree-category/modal-tree-category.component';
import { ModalUploadImageComponent } from './modal-upload-image/modal-upload-image.component';
import { ToastrService } from 'ngx-toastr';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  CategoryService,
  BrandService,
  ProductService,
  ProductTypeService,
  ProductTypeValueService,
  ProductRepoService,
  ProductRepoTypeValueService,
  OrderService,
} from '@app/api/api';
import { CurrencyPipe } from '@angular/common';
import { ManufacturerService } from '../../../../api/manufacturer.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalCreateBrandComponent } from '../brand-management/modal-create-brand/modal-create-brand.component';
import { ModalCreateProducerComponent } from '../producer-management/modal-create-producer/modal-create-producer.component';
import { environment } from 'environments/environment';
import moment from 'moment';
import { UtilService } from '@app/services/util.service';
import $ from 'jquery';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'meu-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss'],
})
export class EditProductComponent implements OnInit, OnDestroy {
  isUpdateLangEng: boolean = false;
  isUpdateLangCn: boolean = false;

  idProductEng: string;
  idProductCn: string;

  dimensionUnits: string[] = ['mm', 'cm', 'm', 'inch'];

  dimensionLengthUnit = 'cm';
  dimensionWidthUnit = 'cm';
  dimensionHeightUnit = 'cm';

  // SEO properties
  private pageTitle: string = 'Quản lý sản phẩm';
  // config = {
  //   placeholder: 'Product detailed description',
  //   tabsize: 2,
  //   height: 'auto',
  //   dialogsInBody: true,
  //   minHeight: '35vh',
  //   uploadImagePath: '/api/upload',
  //   focus: false,
  //   tooltip: false,
  //   toolbar: [
  //     ['misc', ['codeview', 'undo', 'redo']],
  //     [
  //       'font',
  //       ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear'],
  //     ],
  //     ['fontsize', ['fontname', 'fontsize', 'color']],
  //     ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
  //     ['insert', ['table', 'picture', 'link', 'video', 'hr']],
  //   ],
  //   fontNames: [
  //     'Helvetica',
  //     'Arial',
  //     'Arial Black',
  //     'Comic Sans MS',
  //     'Courier New',
  //     'Roboto',
  //     'Times',
  //   ],
  // };

  // Summernote configuration for detailed product description
  config = {
    placeholder: 'Mô tả chi tiết sản phẩm',
    tabsize: 2,
    height: 'auto',
    dialogsInBody: true, // Already configured - helps modal functionality
    minHeight: '35vh',
    uploadImagePath: '/api/upload',
    focus: false,
    tooltip: false,

    // FIX: Add this line to make fonts work properly
    fontNamesIgnoreCheck: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
    ],

    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      [
        'font',
        ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear'],
      ],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']],
      ['view', ['fullscreen', 'codeview', 'help']],
    ],

    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
    ],

    // FIX: Add callbacks to handle paste from Word with formatting
    callbacks: {
      onPaste: (e: any) => {
        const clipboardData = (e.originalEvent || e).clipboardData || (window as any).clipboardData;

        // Get both text and HTML from clipboard
        let htmlData = clipboardData.getData('text/html');
        const textData = clipboardData.getData('text/plain');

        e.preventDefault();

        // If there's HTML data (from Word, Excel, etc.)
        if (htmlData) {
          const div = document.createElement('div');
          div.innerHTML = htmlData;

          // Process tables from Word/Excel
          const tables = div.querySelectorAll('table');
          tables.forEach((table) => {
            // Keep table structure and basic CSS
            table.setAttribute('border', '1');
            table.style.borderCollapse = 'collapse';
            table.style.width = '100%';
            table.style.maxWidth = '100%';

            // Process cells
            const cells = table.querySelectorAll('td, th');
            cells.forEach((cell) => {
              const cellElement = cell as HTMLElement;
              // Keep text color if available
              const computedStyle = window.getComputedStyle(cellElement);
              if (computedStyle.color && computedStyle.color !== 'rgb(0, 0, 0)') {
                cellElement.style.color = computedStyle.color;
              }
              // Add padding for cells
              cellElement.style.padding = '8px';
              cellElement.style.border = '1px solid #ccc';
            });
          });

          // Process text color for regular text
          const coloredElements = div.querySelectorAll('*[style*="color"], span[style*="color"]');
          coloredElements.forEach((el) => {
            const element = el as HTMLElement;
            const style = element.getAttribute('style');
            if (style && style.includes('color:')) {
              // Keep color style
              const colorMatch = style.match(/color:\s*([^;]+)/);
              if (colorMatch) {
                element.style.color = colorMatch[1];
              }
            }
          });

          // Remove unnecessary styles from Word
          const allElements = div.querySelectorAll('*');
          allElements.forEach((el) => {
            // Remove Word classes
            const classList = Array.from(el.classList);
            classList.forEach((className) => {
              if (className.startsWith('Mso') || className.startsWith('ms-')) {
                el.classList.remove(className);
              }
            });

            // Keep important styles
            const currentStyle = el.getAttribute('style');
            if (currentStyle) {
              const stylesToKeep = [];

              // Keep text color
              const colorMatch = currentStyle.match(/color:\s*([^;]+)/);
              if (colorMatch) {
                stylesToKeep.push(`color: ${colorMatch[1]}`);
              }

              // Keep background color
              const bgColorMatch = currentStyle.match(/background-color:\s*([^;]+)/);
              if (bgColorMatch) {
                stylesToKeep.push(`background-color: ${bgColorMatch[1]}`);
              }

              // Keep font weight (bold)
              const fontWeightMatch = currentStyle.match(/font-weight:\s*([^;]+)/);
              if (fontWeightMatch) {
                stylesToKeep.push(`font-weight: ${fontWeightMatch[1]}`);
              }

              // Reset style with what needs to be kept
              el.setAttribute('style', stylesToKeep.join('; '));
            }
          });

          document.execCommand('insertHTML', false, div.innerHTML);
        } else {
          // Fallback for plain text
          document.execCommand('insertText', false, textData);
        }
      },
    },
  };

  // configSummary = {
  //   placeholder: 'Product summary description',
  //   tabsize: 2,
  //   height: 'auto',
  //   minHeight: '17vh',
  //   maxHeight: '60vh',
  //   uploadImagePath: '/api/upload',
  //   focus: false,
  //   tooltip: false,
  //   toolbar: [
  //     ['misc', ['codeview']],
  //     ['font', ['bold', 'italic', 'underline', 'superscript', 'subscript']],
  //     ['fontsize', ['fontname', 'fontsize', 'color']],
  //     ['para', ['ul', 'ol', 'paragraph']],
  //     ['insert', ['link']],
  //   ],
  //   fontNames: [
  //     'Helvetica',
  //     'Arial',
  //     'Arial Black',
  //     'Comic Sans MS',
  //     'Courier New',
  //     'Roboto',
  //     'Times',
  //   ],
  // };

  configSummary = {
    placeholder: 'Mô tả tổng quan sản phẩm',
    tabsize: 2,
    height: 'auto',
    minHeight: '17vh',
    maxHeight: '60vh',
    uploadImagePath: '/api/upload',
    focus: false,
    tooltip: false,
    dialogsInBody: true,

    toolbar: [
      ['misc', ['codeview']],
      ['font', ['bold', 'italic', 'underline', 'superscript', 'subscript']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['insert', ['link']],
    ],

    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
    ],

    fontNamesIgnoreCheck: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
    ],

    callbacks: {
      onPaste: (e: any) => {
        const clipboardData = (e.originalEvent || e).clipboardData || (window as any).clipboardData;

        // Get both text and HTML from clipboard
        let htmlData = clipboardData.getData('text/html');
        const textData = clipboardData.getData('text/plain');

        e.preventDefault();

        // If there's HTML data (from Word, Excel, etc.)
        if (htmlData) {
          const div = document.createElement('div');
          div.innerHTML = htmlData;

          // Process text color for regular text
          const coloredElements = div.querySelectorAll('*[style*="color"], span[style*="color"]');
          coloredElements.forEach((el) => {
            const element = el as HTMLElement;
            const style = element.getAttribute('style');
            if (style && style.includes('color:')) {
              // Keep color style
              const colorMatch = style.match(/color:\s*([^;]+)/);
              if (colorMatch) {
                element.style.color = colorMatch[1];
              }
            }
          });

          // Remove unnecessary styles from Word but keep colors
          const allElements = div.querySelectorAll('*');
          allElements.forEach((el) => {
            // Remove Word classes
            const classList = Array.from(el.classList);
            classList.forEach((className) => {
              if (className.startsWith('Mso') || className.startsWith('ms-')) {
                el.classList.remove(className);
              }
            });

            // Keep important styles
            const currentStyle = el.getAttribute('style');
            if (currentStyle) {
              const stylesToKeep = [];

              // Keep text color
              const colorMatch = currentStyle.match(/color:\s*([^;]+)/);
              if (colorMatch) {
                stylesToKeep.push(`color: ${colorMatch[1]}`);
              }

              // Keep font weight (bold)
              const fontWeightMatch = currentStyle.match(/font-weight:\s*([^;]+)/);
              if (
                fontWeightMatch &&
                (fontWeightMatch[1] === 'bold' || parseInt(fontWeightMatch[1]) >= 700)
              ) {
                stylesToKeep.push(`font-weight: ${fontWeightMatch[1]}`);
              }

              // Reset style with what needs to be kept
              if (stylesToKeep.length > 0) {
                el.setAttribute('style', stylesToKeep.join('; '));
              } else {
                el.removeAttribute('style');
              }
            }
          });

          document.execCommand('insertHTML', false, div.innerHTML);
        } else {
          // Fallback for plain text
          document.execCommand('insertText', false, textData);
        }
      },
    },
  };

  isEdit = true;
  productId;
  productName = '';
  imgSelectedIndex = 0;
  productData = {
    extend_images: [],
  };
  sort_order_next = 0;

  touched = false;

  hasFormErrors: boolean = false;
  infoBasicForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    product_category_id: new FormControl(),
    brand_id: new FormControl('', [Validators.required]),
    description: new FormControl(),
    price: new FormControl(),
    origin_price: new FormControl(),
    product_code: new FormControl('', [Validators.required]),
    summary: new FormControl('', [Validators.required]),
    tags: new FormControl(),
    manyfacturer_id: new FormControl(),
    manufacturer_name: new FormControl(),
    brand_name: new FormControl(),
    is_hidden: new FormControl(),
    is_new_arrival: new FormControl(false),
    sku: new FormControl('', [Validators.required]),
    promotion_from: new FormControl(),
    promotion_deadline: new FormControl(),
    promotion_time_limited: new FormControl(),
    quantity: new FormControl(),
    default_image: new FormControl(),
    warranty: new FormControl(),
    shipping_fee: new FormControl(),
    dimension_length: new FormControl(null),
    dimension_width: new FormControl(null),
    dimension_height: new FormControl(null),
    weight: new FormControl(null),
    hs_code: new FormControl(null),
  });

  infoBasicFormEng = new FormGroup({
    product_id: new FormControl(),
    name: new FormControl('', [Validators.required]),
    description: new FormControl(),
    summary: new FormControl('', [Validators.required]),
  });

  infoBasicFormCn = new FormGroup({
    product_id: new FormControl(),
    name: new FormControl('', [Validators.required]),
    description: new FormControl(),
    summary: new FormControl('', [Validators.required]),
  });

  promotion_time_limited;
  promotion_from;
  promotion_deadline;

  productCategoryID = '';

  path = '';

  arrHashtag = [];
  strTag = '';
  myControl = new FormControl();

  listWarehouse = [];
  listIDProductRepoDelete = [];
  listIDProductRepoPrivateDelete = [];

  all_price: any = '';
  all_origin_price: any = '';
  all_quantity;
  all_SKUCode = '';

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.elementInView();
  }

  onResize(event) {
    this.elementInView();
  }

  isPromotion = false;
  vatValue = 0;

  public controlSearchManufacturer: FormControl = new FormControl();
  public keyUpManufacturer = new Subject<KeyboardEvent>();
  dataSearchBasicManufacturer: any = '';
  filterManufacturer = '';
  totalPageManufacturer = 0;
  pageManufacturer = 1;
  listManufacturer = [];
  selectManufacturerID;

  public controlSearch: FormControl = new FormControl();
  public keyUp = new Subject<KeyboardEvent>();
  dataSearchBasic: any = '';
  filterBrand = '';
  totalPage = 0;
  page = 1;
  listBrand = [];
  selectBrandID;

  listCategory = [];
  listDatatableCategory = [];

  listIDImgDelete = [];

  listIDSubCatDelete = [];
  indexDrop = [];

  treeData = [];
  TREE = [];
  load_tree_path = [];

  id_default_image;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private brandService: BrandService,
    private currencyPipe: CurrencyPipe,
    private router: Router,
    private productService: ProductService,
    private productTypeService: ProductTypeService,
    private productTypeValueService: ProductTypeValueService,
    private productRepoService: ProductRepoService,
    private productRepoTypeValueService: ProductRepoTypeValueService,
    private manufacturerService: ManufacturerService,
    private route: ActivatedRoute,
    private categoryService: CategoryService,
    private orderService: OrderService,
    private http: HttpClient,
    private titleService: Title,
    private metaService: Meta
  ) {}

  ngOnInit() {
    // Setup SEO for admin page
    this.setupAdminSEO();

    this.orderService.apiOrdersVatConfigGet().subscribe((res) => {
      if (res && res.success) {
        this.vatValue = res.data || 0;
      }
    });
    this.categoryService.apiCategoriesWithPriority(false, 'body', true).subscribe((r) => {
      if (r.success) {
        this.treeData = r.data;
        this.TREE = this.buildTree(this.treeData);
      }
    });
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(300)
      )
      .subscribe((value) => {
        this.dataSearchBasic = value;
        this.filterBrand = 'name@=*' + this.dataSearchBasic;
        this.page = 1;
        this.listBrand = [];
        this.getListBrand();
      });

    this.keyUpManufacturer
      .pipe(
        map((event) => event),
        debounceTime(300)
      )
      .subscribe((value) => {
        this.dataSearchBasicManufacturer = value;
        this.filterManufacturer = 'name@=*' + this.dataSearchBasicManufacturer;
        this.pageManufacturer = 1;
        this.listManufacturer = [];
        this.getListManufacture();
      });

    this.getListBrand();
    this.getListManufacture();

    if (
      this.route.snapshot.params.productId != null &&
      this.route.snapshot.params.productId !== '' &&
      this.route.snapshot.params.productId !== undefined
    ) {
      this.productId = this.route.snapshot.params.productId;
      this.isEdit = true;
      this.getProductByID();
      this.getProductWithEngAndChName();
    } else {
      this.isEdit = false;
    }
  }

  ngOnDestroy() {
    this.changeDetectorRef.detach();
  }

  uploadImageWithProgress(productId: string, file: File, summary: string = ''): void {
    if (!productId || !file) return;
    const sortOrder = this.productData.extend_images ? this.productData.extend_images.length : 0;
    this.productService
      .uploadProductImage(productId, file, sortOrder, summary, 'events', true)
      .subscribe(
        (event: any) => {
          // HttpEventType from @angular/common/http can be used to switch on event.type
          if (event.type === 1) {
            // UploadProgress
            const percentDone = Math.round((100 * event.loaded) / event.total);
            // update UI progress bar / disable button
            console.log('Upload progress', percentDone);
          } else if (event.type === 4) {
            // Response
            const res = event.body;
            if (res && res.success) {
              this.toastr.success('Upload ảnh thành công');
              this.getProductByID();
            } else {
              this.toastr.error(res && res.message ? res.message : 'Upload thất bại');
            }
          }
        },
        (err) => {
          console.error(err);
          this.toastr.error('Upload thất bại');
        }
      );
  }

  buildTree(data) {
    let rootNode = data.filter((x) => x.parent_id == null);
    let treeobject = [];
    rootNode.forEach((element) => {
      let aChildren = data.filter((x) => x.parent_id == element.id);
      const node = new Object();
      node['id'] = element.id;
      node['name'] = element.name;
      node['parent_id'] = element.parent_id;
      node['path'] = element.name;
      let lstChildren = this.builDataChildren(aChildren, data, node);
      node['children'] = lstChildren;
      treeobject.push(node);
      this.load_tree_path.push(node);
    });
    return treeobject;
  }

  builDataChildren(aChildren, allChildren, parent) {
    let objectReturn = [];
    aChildren.forEach((element) => {
      let aChild = allChildren.filter((x) => x.parent_id == element.id);
      const node = new Object();
      node['id'] = element.id;
      node['name'] = element.name;
      node['path'] = parent.path + ' › ' + element.name;
      let lstChildrenNode = this.builDataChildren(aChild, allChildren, node);
      node['children'] = lstChildrenNode;
      objectReturn.push(node);
      this.load_tree_path.push(node);
    });
    return objectReturn;
  }

  getProductByID() {
    this.productService.apiProductsIdGet(this.productId).subscribe(async (res) => {
      if (res.success) {
		const lengthDimension = this.parseDimension(
			res.data.dimension_length
		);

		const widthDimension = this.parseDimension(
			res.data.dimension_width
		);

		const heightDimension = this.parseDimension(
			res.data.dimension_height
		);

			this.dimensionLengthUnit = lengthDimension.unit;
			this.dimensionWidthUnit = widthDimension.unit;
			this.dimensionHeightUnit = heightDimension.unit;
        this.infoBasicForm.patchValue({
          name: res.data.name,
          product_category_id: res.data.product_category_id,
          brand_id: res.data.brand_id,
          description: res.data.description,
          price: this.transformCurrency(res.data.price),
          origin_price: this.transformCurrency(res.data.origin_price),
          product_code: res.data.product_code,
          summary: res.data.summary,
          tags: res.data.tags,
          manyfacturer_id: res.data.manyfacturer_id,
          manufacturer_name: res.data.manufacturer_name,
          brand_name: res.data.brand_name,
          sku: res.data.sku,
          is_hidden: res.data.is_hidden,
          is_new_arrival: !!res.data.is_new_arrival,
          promotion_from: new Date(
            moment(res.data.promotion_from).subtract(7, 'hour').format('YYYY-MM-DD HH:mm')
          ),
          promotion_deadline: new Date(
            moment(res.data.promotion_deadline).subtract(7, 'hour').format('YYYY-MM-DD HH:mm')
          ),
          promotion_time_limited: res.data.promotion_time_limited,
          quantity: res.data.quantity,
          default_image: res.data.default_image,
          warranty: res.data.warranty,
          shipping_fee: res.data.shipping_fee,
          dimension_length: lengthDimension.value,
		  dimension_width: widthDimension.value,
		  dimension_height: heightDimension.value,
          weight: res.data.weight,
          hs_code: res.data.hs_code,
        });

        this.productName = res.data.name;

        let item_tree = this.load_tree_path.find((x) => x.id == res.data.product_category_id);
        if (item_tree) {
          this.path = item_tree.path;
        }

        this.productCategoryID = res.data.product_category_id;
        this.isPromotion = res.data.promotion_time_limited == true ? true : false;

        this.selectBrandID = res.data.brand_id;
        this.selectManufacturerID = res.data.manyfacturer_id;
        if (this.selectBrandID) {
          let item = this.listBrand.find((x) => x.id == this.selectBrandID);
          if (!item) {
            this.brandService.apiBrandsIdGet(this.selectBrandID).subscribe((resBrand) => {
              if (resBrand.success) {
                this.listBrand.push({
                  id: resBrand.data.id,
                  name: resBrand.data.name,
                });
              }
              if (!this.changeDetectorRef['destroyed']) {
                this.changeDetectorRef.detectChanges();
              }
            });
          }
        }
        if (this.selectManufacturerID) {
          let item = this.listManufacturer.find((x) => x.id == this.selectManufacturerID);
          if (!item) {
            this.manufacturerService
              .apiManufacturerIdGet(this.selectManufacturerID)
              .subscribe((resManufacturer) => {
                if (resManufacturer.success) {
                  this.listManufacturer.push({
                    id: resManufacturer.data.id,
                    name: resManufacturer.data.name,
                  });
                }
                if (!this.changeDetectorRef['destroyed']) {
                  this.changeDetectorRef.detectChanges();
                }
              });
          }
        }

        let lstHashtag = res.data.tags != null ? res.data.tags.split(',') : [];
        for (let i = 0; i < lstHashtag.length; i++) {
          this.arrHashtag.push(lstHashtag[i]);
        }
        // Reset existing image list before repopulating to avoid duplicates and store full product details
        this.productData = Object.assign({}, res.data, {
          extend_images: []
        });
        let data_sort = res.data.extend_images.sort((a, b) =>
          a.sort_order > b.sort_order ? 1 : -1
        );
        for (let i = 0; i < data_sort.length; i++) {
          data_sort[i].physical_path = environment.backendhost + data_sort[i].physical_path;
          this.productData.extend_images.push({
            id: data_sort[i].id,
            index: this.productData.extend_images.length,
            physical_path: data_sort[i].physical_path,
            file: null,
            summary: data_sort[i].summary ? data_sort[i].summary : '',
            is_new: false,
            sort_order: data_sort[i].sort_order,
            is_edit: false,
          });
        }

        this.sort_order_next =
          this.productData.extend_images[this.productData.extend_images.length - 1].sort_order + 1;

        let imgItem = this.productData.extend_images.find(
          (x) => x.physical_path == environment.backendhost + res.data.default_image
        );
        this.id_default_image = imgItem ? imgItem.id : '';

        this.productData = Object.assign({}, this.productData, {
          extend_images: this.productData.extend_images,
          extend_product_type: res.data.extend_product_type,
          extend_type: res.data.extend_type,
          extend_supplier_quotes: res.data.extend_supplier_quotes,
          name: res.data.name
        });
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }

        this.productRepoService
          .apiProductProductIDProductRepositoriesGet(this.productId, '', '', 1, 100000)
          .subscribe((resultRepo) => {
            if (resultRepo.success) {
              for (let i = 0; i < resultRepo.data.collection.length; i++) {
                this.listWarehouse.push({
                  id: resultRepo.data.collection[i].id,
                  product_id: resultRepo.data.collection[i].product_id,
                  repo_id: resultRepo.data.collection[i].repo_id,
                  name: resultRepo.data.collection[i].extend_repo_name,
                  quantity: resultRepo.data.collection[i].quantity,
                  SKUCode: resultRepo.data.collection[i].sku,
                  leadtime: resultRepo.data.collection[i].leadtime || '',
                  code: resultRepo.data.collection[i].extend_repo_code,
                  address: resultRepo.data.collection[i].extend_repo_address,
                  id_delete: resultRepo.data.collection[i].id,
                  is_new: false,
                });
              }
            }
          });

        let extendType = res.data.extend_type;

        let arrIDType = [];
        for (let i = 0; i < extendType.length; i++) {
          this.listCategory.push({
            index: this.listCategory.length,
            name: extendType[i].group_name,
            listCat: [],
          });
          for (let j = 0; j < extendType[i].types.length; j++) {
            this.listCategory[i].listCat.push({
              id: extendType[i].types[j].id,
              nameSubCat: extendType[i].types[j].name,
              indexSubCat: this.listCategory[i].listCat.length,
              is_new: false,
            });

            if (i == 0) {
              arrIDType.push({
                parentId: extendType[i].types[j].id,
                childId: [],
              });
            } else {
              for (let x = 0; x < arrIDType.length; x++) {
                arrIDType[x].childId.push(extendType[i].types[j].id);
              }
            }
          }
        }

        this.initTableCategory();

        let arrIdTypeValue = [];
        for (let i = 0; i < arrIDType.length; i++) {
          for (let j = 0; j < arrIDType[i].childId.length; j++) {
            arrIdTypeValue.push({
              i: i,
              j: j,
              type_id: [arrIDType[i].parentId, arrIDType[i].childId[j]].sort(),
            });
          }
          if (arrIDType[i].childId.length == 0) {
            arrIdTypeValue.push({
              i: i,
              j: 0,
              type_id: [arrIDType[i].parentId].sort(),
            });
          }
        }

        let extendProductTypeValue = res.data.extend_product_type;
        for (let i = 0; i < extendProductTypeValue.length; i++) {
          extendProductTypeValue[i].type_id = extendProductTypeValue[i].type_id.sort();
          for (let j = 0; j < arrIdTypeValue.length; j++) {
            if (
              JSON.stringify(extendProductTypeValue[i].type_id) ==
              JSON.stringify(arrIdTypeValue[j].type_id)
            ) {
              this.listDatatableCategory[arrIdTypeValue[j].i].price[arrIdTypeValue[j].j].value =
                this.transformCurrency(extendProductTypeValue[i].price);
              this.listDatatableCategory[arrIdTypeValue[j].i].origin_price[
                arrIdTypeValue[j].j
              ].value = this.transformCurrency(extendProductTypeValue[i].origin_price);

              await this.productRepoTypeValueService
                .apiProductRepoTypeValuesGet(
                  'type_value_id==' + extendProductTypeValue[i].id,
                  '',
                  1,
                  100000
                )
                .toPromise()
                .then((res) => {
                  if (res.success) {
                    let arrWarehouse = res.data.collection;
                    if (arrWarehouse.length == 0) {
                      this.listDatatableCategory[arrIdTypeValue[j].i].totalLine += 1;
                    } else {
                      this.listDatatableCategory[arrIdTypeValue[j].i].totalLine +=
                        arrWarehouse.length;
                    }
                    for (let x = 0; x < arrWarehouse.length; x++) {
                      this.listDatatableCategory[arrIdTypeValue[j].i].subCat[
                        arrIdTypeValue[j].j
                      ].warehouse.push({
                        id: arrWarehouse[x].repo_id,
                        name: arrWarehouse[x].extend_repo_name,
                        code: '',
                        address: '',
                        quantity: arrWarehouse[x].quantity,
                        SKUCode: arrWarehouse[x].sku,
                        leadtime: arrWarehouse[x].leadtime || '',
                        type_value_id: arrWarehouse[x].type_value_id,
                        id_update: arrWarehouse[x].id,
                      });
                      this.listDatatableCategory[arrIdTypeValue[j].i].price[
                        arrIdTypeValue[j].j
                      ].warehouse.push({
                        id: arrWarehouse[x].repo_id,
                        name: arrWarehouse[x].extend_repo_name,
                        code: '',
                        address: '',
                        quantity: arrWarehouse[x].quantity,
                        SKUCode: arrWarehouse[x].sku,
                        leadtime: arrWarehouse[x].leadtime || '',
                        type_value_id: arrWarehouse[x].type_value_id,
                        id_update: arrWarehouse[x].id,
                      });
                      this.listDatatableCategory[arrIdTypeValue[j].i].origin_price[
                        arrIdTypeValue[j].j
                      ].warehouse.push({
                        id: arrWarehouse[x].repo_id,
                        name: arrWarehouse[x].extend_repo_name,
                        code: '',
                        address: '',
                        quantity: arrWarehouse[x].quantity,
                        SKUCode: arrWarehouse[x].sku,
                        leadtime: arrWarehouse[x].leadtime || '',
                        type_value_id: arrWarehouse[x].type_value_id,
                        id_update: arrWarehouse[x].id,
                      });
                    }
                  }
                });
            }
          }
        }
      } else {
        this.toastr.error('Đã xảy ra lỗi!');
      }
    });
  }

  getProductWithEngAndChName() {
    this.productService.apiProductsIdGet(this.productId).subscribe((res) => {
      if (res.success) {
        if (
          res.data.extend_product_en !== null &&
          res.data.extend_product_en !== undefined &&
          res.data.extend_product_en !== ''
        ) {
          this.idProductEng = res.data.extend_product_en.id;
          this.infoBasicFormEng.patchValue({
            product_id: res.data.id,
            name: res.data.extend_product_en.name,
            description: res.data.extend_product_en.description,
            summary: res.data.extend_product_en.summary,
          });
          this.isUpdateLangEng = true;
        }
        if (
          res.data.extend_product_zh !== null &&
          res.data.extend_product_zh !== undefined &&
          res.data.extend_product_zh !== ''
        ) {
          this.idProductCn = res.data.extend_product_zh.id;
          this.infoBasicFormCn.patchValue({
            product_id: res.data.id,
            name: res.data.extend_product_zh.name,
            description: res.data.extend_product_zh.description,
            summary: res.data.extend_product_zh.summary,
          });
          this.isUpdateLangCn = true;
        }
      } else {
        this.toastr.error('Đã xảy ra lỗi!');
      }
    });
  }

  checkFormValid(form: FormGroup): boolean {
    form.markAllAsTouched();
    return form.valid;
  }

  addProductLanguage(typeLang: 'productZh' | 'productEn') {
    let formToCheck: FormGroup =
      typeLang === 'productEn' ? this.infoBasicFormEng : this.infoBasicFormCn;

    if (!this.checkFormValid(formToCheck)) {
      this.toastr.error('Vui lòng điền đẩy đủ thông in');
      return;
    }
    formToCheck.patchValue({ product_id: this.productId });
    this.productService.apiProductsLangPost(typeLang, formToCheck.value).subscribe((res) => {
      if (res.success) {
        this.toastr.success('Thêm thành công');
      } else {
        this.toastr.error('Đã có lỗi xảy ra');
      }
    });
  }
  updateProductLanguage(typeLang: 'productZh' | 'productEn') {
    let formToCheck: FormGroup =
      typeLang === 'productEn' ? this.infoBasicFormEng : this.infoBasicFormCn;
    let productID: string = typeLang === 'productEn' ? this.idProductEng : this.idProductCn;
    if (!this.checkFormValid(formToCheck)) {
      this.toastr.error('Vui lòng điền đẩy đủ thông in');
      return;
    }
    formToCheck.patchValue({ product_id: this.productId });

    this.productService
      .apiProductsLangPut(typeLang, productID, formToCheck.value)
      .subscribe((res) => {
        if (res.success) {
          this.toastr.success('Chỉnh sửa thành công');
        } else {
          this.toastr.error('Đã có lỗi xảy ra');
        }
      });
  }
  getListBrand() {
    this.brandService.apiBrandsGet(this.filterBrand, '', this.page, 10).subscribe((res) => {
      if (res.success) {
        this.totalPage = Math.ceil(res.data.total / 10);
        for (let i = 0; i < res.data.collection.length; i++) {
          let index = this.listBrand.findIndex((x) => x.id == res.data.collection[i].id);
          if (index == -1) {
            this.listBrand.push({
              id: res.data.collection[i].id,
              name: res.data.collection[i].name,
            });
          }
        }
      }
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  getListManufacture() {
    this.manufacturerService
      .apiManufacturerGet(this.filterManufacturer, '', this.pageManufacturer, 10)
      .subscribe((res) => {
        if (res.success) {
          this.totalPageManufacturer = Math.ceil(res.data.total / 10);
          for (let i = 0; i < res.data.collection.length; i++) {
            let index = this.listManufacturer.findIndex((x) => x.id == res.data.collection[i].id);
            if (index == -1) {
              this.listManufacturer.push({
                id: res.data.collection[i].id,
                name: res.data.collection[i].name,
              });
            }
          }
        }
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      });
  }

  loadMore() {
    this.page = this.page + 1;
    this.getListBrand();
  }

  loadMoreManufacture() {
    this.pageManufacturer = this.pageManufacturer + 1;
    this.getListManufacture();
  }

  search(event) {}

  searchManufacture(event) {}

  chooseBrand(item) {
    this.infoBasicForm.patchValue({
      brand_name: item.name,
    });
  }

  chooseManufacture(item) {
    this.infoBasicForm.patchValue({
      manufacturer_name: item.name,
    });
  }

  addNewBrand() {
    const dialogRef = this.dialog.open(ModalCreateBrandComponent, {
      width: '900px',
      data: { name: this.controlSearch.value },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.filterBrand = '';
      this.page = 1;
      this.listBrand = [];
      this.getListBrand();
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
      if (result && result.event) {
        this.selectBrandID = result.newItem.id;
        this.infoBasicForm.patchValue({
          brand_name: result.newItem.name,
        });
      }
    });
  }

  addNewManufacturer() {
    const dialogRef = this.dialog.open(ModalCreateProducerComponent, {
      width: '900px',
      data: { name: this.controlSearchManufacturer.value },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.filterManufacturer = '';
      this.pageManufacturer = 1;
      this.listManufacturer = [];
      this.getListManufacture();
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
      if (result && result.event) {
        this.selectManufacturerID = result.newItem.id;
        this.infoBasicForm.patchValue({
          manufacturer_name: result.newItem.name,
        });
      }
    });
  }

  scrollProductViewed(value) {
    document.getElementById('scroll-element').scrollLeft += value;
  }
  scrollProductImg(value) {
    document.getElementById('scroll-img').scrollLeft += value;
  }

  elementInView() {
    var elmnt = document.getElementById('container-edit-product');
    let widthElement = elmnt.offsetWidth;

    const pageTop = $(window).scrollTop();
    const pageBottom = pageTop + $(window).height();
    const elementTop = $('#footer').offset().top;
    const elementBottom = elementTop + $('#footer').height();
    if (!(elementTop <= pageBottom && elementBottom >= pageTop)) {
      $('.desktop-actions-footer').addClass('kt-footer-mobile kt-footer--fixed');
      $('.desktop-actions-footer').attr('id', 'fixed-footer');
      document.getElementById('fixed-footer').style.width = widthElement + 'px';
    } else {
      $('.desktop-actions-footer').removeClass('kt-footer-mobile kt-footer--fixed');
      $('.desktop-actions-footer').removeAttr('id');
      $('.desktop-actions-footer').removeAttr('style');
    }
  }

  transformCurrency(value) {
    if (value == '' || value == null || value == undefined) {
      return '0';
    }
    let val = value.toString();
    if (val != null) {
      val = val.replace(/[^0-9.-]+/g, '');
      return this.currencyPipe.transform(val, 'VND', '');
    }
  }
  transformCurrencyForApplyAll(value) {
    if (value == '' || value == null || value == undefined) {
      return '';
    }
    let val = value.toString();
    if (val != null) {
      val = val.replace(/[^0-9.-]+/g, '');
      return this.currencyPipe.transform(val, 'VND', '');
    }
  }

  deleteImg(id) {
    if (this.isEdit) {
      let item = this.productData.extend_images.find((x) => x.id == id);
      if (!item.is_new) {
        this.listIDImgDelete.push(item.id);
      }
    }
    let index = this.productData.extend_images.findIndex((x) => x.id == id);
    this.productData.extend_images.splice(index, 1);
    if (this.productData.extend_images.length > 0) {
      if (this.productData.extend_images[0].is_new) {
        this.productData.extend_images[0].id = '1';
      }
      this.id_default_image = this.productData.extend_images[0].id;
    }
    if (this.imgSelectedIndex > 0) {
      this.imgSelectedIndex--;
    }
  }

  addImage() {
    const dialogRef = this.dialog.open(ModalUploadImageComponent, {
      width: '800px',
      data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.event) {
        if (this.isEdit && this.productId) {
          this.toastr.success('Upload ảnh thành công');
          this.uploadImageWithProgress(this.productId, result.file, result.summary);
        } else {
          this.toastr.success('Đã thêm ảnh');
          let id = '';
          if (this.productData.extend_images.length == 0) {
            id = '1';
          }
          this.productData.extend_images.push({
            id: id,
            index: this.productData.extend_images.length,
            physical_path: result.physical_path,
            file: result.file,
            summary: result.summary,
            is_new: true,
            sort_order: this.productData.extend_images.length,
            is_edit: false,
          });
          if (this.productData.extend_images.length > 0) {
            this.id_default_image = this.productData.extend_images[0].id;
          }
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
        }
      }
    });
  }

  editImageSelected() {
    const dialogRef = this.dialog.open(ModalUploadImageComponent, {
      width: '800px',
      data: { itemImage: this.productData.extend_images[this.imgSelectedIndex] },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.event) {
        this.toastr.success('Đóng modal chỉnh sửa ảnh');
        let id = '';
        if (this.imgSelectedIndex == 0) {
          id = '1';
        }
        let obj = {
          id: id,
          index: this.productData.extend_images[this.imgSelectedIndex].index,
          physical_path: result.physical_path,
          file: result.file,
          summary: result.summary,
          is_new: true,
          sort_order: this.productData.extend_images[this.imgSelectedIndex].sort_order,
          is_edit: this.productData.extend_images[this.imgSelectedIndex].is_new ? false : true,
        };

        this.productData.extend_images[this.imgSelectedIndex] = obj;

        if (this.productData.extend_images.length > 0) {
          this.id_default_image = this.productData.extend_images[0].id;
        }
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      }
    });
  }

  openModalTree() {
    const dialogRef = this.dialog.open(ModalTreeCategoryComponent, {
      width: '650px',
      data: { treeData: this.treeData },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.event) {
        this.path = result.path;
        this.infoBasicForm.value.product_category_id = result.id;
        this.productCategoryID = result.id;
        this.toastr.success('Chọn danh mục sản phẩm thành công');
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      }
    });
  }

  openModalRepository() {
    let productId = '';
    if (this.isEdit) {
      productId = this.productId;
    }
    const dialogRef = this.dialog.open(ModalChooseRepositoryComponent, {
      width: '800px',
      data: { listRepository: this.listWarehouse, productId: productId, isEdit: this.isEdit },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.event) {
        this.listWarehouse = result.data;
        this.listIDProductRepoDelete = result.listProductRepoIdDelete;
        this.toastr.success('Chọn kho hàng thành công');
      }
    });
  }

  closeGroupCategory(index) {
    if (this.isEdit) {
      for (let j = 0; j < this.listCategory[index].listCat.length; j++) {
        if (!this.listCategory[index].listCat[j].is_new) {
          this.listIDSubCatDelete.push(this.listCategory[index].listCat[j].id);
        }
      }
    }

    if (this.listCategory.length == 1) {
      this.listCategory = [];
    } else {
      this.listCategory = this.listCategory.splice(index - 1, 1);
      this.updateIndex();
    }
    this.listDatatableCategory = [];
    this.initTableCategory();
  }
  addSubCat(index) {
    this.listCategory[index].listCat.push({
      nameSubCat: '',
      indexSubCat: this.listCategory[index].listCat.length,
      id: '',
      is_new: true,
    });
  }
  addGroupCat() {
    if (this.listCategory.length < 2) {
      this.listCategory.push({
        index: this.listCategory.length,
        name: '',
        listCat: [],
      });
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  deleteSubCat(index, subIndex) {
    if (this.isEdit && !this.listCategory[index].listCat[subIndex].is_new) {
      this.listIDSubCatDelete.push(this.listCategory[index].listCat[subIndex].id);
    }
    let listCat = this.listCategory[index].listCat;
    listCat.splice(subIndex, 1);
    this.updateIndex();

    if (index == 0) {
      this.listDatatableCategory.splice(subIndex, 1);
    } else {
      for (let i = 0; i < this.listDatatableCategory.length; i++) {
        this.listDatatableCategory[i].subCat.splice(subIndex, 1);
        this.listDatatableCategory[i].price.splice(subIndex, 1);
        this.listDatatableCategory[i].origin_price.splice(subIndex, 1);
      }
    }
  }

  initTableCategory() {
    for (let i = 0; i < this.listCategory.length; i++) {
      if (i == 0) {
        for (let j = 0; j < this.listCategory[i].listCat.length; j++) {
          this.listDatatableCategory.push({
            index: j,
            parentCat: this.listCategory[i].listCat[j].nameSubCat,
            id: this.listCategory[i].listCat[j].id,
            totalLine: 0,
            subCat: [
              {
                nameSubCat: '',
                indexSubCat: 0,
                warehouse: [],
              },
            ],
            price: [
              {
                value: 0,
                indexPrice: 0,
                warehouse: [],
              },
            ],
            origin_price: [
              {
                value: 0,
                indexPrice: 0,
                warehouse: [],
              },
            ],
          });
        }
      } else {
        for (let x = 0; x < this.listDatatableCategory.length; x++) {
          let arrVal = [];
          let arrOrgVal = [];
          let arrListCat = [];
          for (let j = 0; j < this.listCategory[i].listCat.length; j++) {
            if (
              this.listCategory[i].listCat[j].nameSubCat != null &&
              this.listCategory[i].listCat[j].nameSubCat != undefined &&
              this.listCategory[i].listCat[j].nameSubCat != ''
            ) {
              let objVal = {
                value: 0,
                indexPrice: this.listCategory[i].listCat[j].indexSubCat,
                warehouse: [],
              };

              let objOrgPrice = {
                value: 0,
                indexPrice: this.listCategory[i].listCat[j].indexSubCat,
                warehouse: [],
              };

              let obj = {
                nameSubCat: this.listCategory[i].listCat[j].nameSubCat,
                indexSubCat: this.listCategory[i].listCat[j].indexSubCat,
                id: this.listCategory[i].listCat[j].id,
                warehouse: [],
              };
              arrVal.push(objVal);
              arrOrgVal.push(objOrgPrice);
              arrListCat.push(obj);
            }
          }
          this.listDatatableCategory[x].subCat = arrListCat;
          this.listDatatableCategory[x].price = arrVal;
          this.listDatatableCategory[x].origin_price = arrOrgVal;
        }
      }
    }
  }

  updateIndex() {
    for (let i = 0; i < this.listCategory.length; i++) {
      this.listCategory[i].index = i;
      for (let j = 0; j < this.listCategory[i].listCat.length; j++) {
        this.listCategory[i].listCat[j].indexSubCat = j;
      }
    }
  }

  enterValueCategory(event, index, subIndex) {
    if (index == 0) {
      if (this.listDatatableCategory[subIndex]) {
        this.listDatatableCategory[subIndex].parentCat = event;
      } else {
        this.listDatatableCategory.push({
          index: this.listDatatableCategory.length,
          parentCat: event,
          id: '',
          totalLine: 0,
          subCat: [
            {
              nameSubCat: '',
              indexSubCat: 0,
              warehouse: [],
            },
          ],
          price: [
            {
              value: 0,
              indexPrice: 0,
              warehouse: [],
            },
          ],
          origin_price: [
            {
              value: 0,
              indexPrice: 0,
              warehouse: [],
            },
          ],
        });

        if (this.listCategory.length == 2) {
          let arrVal = [];
          let arrOrgVal = [];
          let arrListCat = [];
          for (let j = 0; j < this.listCategory[1].listCat.length; j++) {
            let objVal = {
              value: 0,
              indexPrice: this.listCategory[1].listCat[j].indexSubCat,
              warehouse: [],
            };

            let objOrgPrice = {
              value: 0,
              indexPrice: this.listCategory[1].listCat[j].indexSubCat,
              warehouse: [],
            };

            let obj = {
              nameSubCat: this.listCategory[1].listCat[j].nameSubCat,
              indexSubCat: this.listCategory[1].listCat[j].indexSubCat,
              id: this.listCategory[1].listCat[j].id,
              warehouse: [],
            };
            arrVal.push(objVal);
            arrOrgVal.push(objOrgPrice);
            arrListCat.push(obj);
          }

          this.listDatatableCategory[this.listDatatableCategory.length - 1].subCat = arrListCat;
          this.listDatatableCategory[this.listDatatableCategory.length - 1].price = arrVal;
          this.listDatatableCategory[this.listDatatableCategory.length - 1].origin_price =
            arrOrgVal;
        }
      }
    } else {
      for (let i = 0; i < this.listDatatableCategory.length; i++) {
        if (this.listDatatableCategory[i].subCat[subIndex]) {
          this.listDatatableCategory[i].subCat[subIndex].nameSubCat = event;
        } else {
          this.listDatatableCategory[i].totalLine += 1;
          this.listDatatableCategory[i].subCat.push({
            nameSubCat: event,
            indexSubCat: this.listDatatableCategory[i].subCat.length,
            id: '',
            warehouse: [],
          });
          this.listDatatableCategory[i].price.push({
            value: 0,
            indexPrice: this.listDatatableCategory[i].subCat.length,
            warehouse: [],
          });
          this.listDatatableCategory[i].origin_price.push({
            value: 0,
            indexPrice: this.listDatatableCategory[i].subCat.length,
            warehouse: [],
          });
        }
      }
    }
  }

  drop(event: CdkDragDrop<string[]>, index) {
    if (event.previousIndex != event.currentIndex) {
      let item = this.indexDrop.find((x) => x == index);
      if (!item) {
        this.indexDrop.push(index);
      }
    }
    moveItemInArray(this.listCategory[index].listCat, event.previousIndex, event.currentIndex);
    this.updateIndex();
    if (index == 0) {
      let obj = this.listDatatableCategory[event.previousIndex];
      if (event.previousIndex > event.currentIndex) {
        for (let j = event.previousIndex; j > event.currentIndex; j--) {
          this.listDatatableCategory[j] = this.listDatatableCategory[j - 1];
        }
      } else {
        for (let j = event.previousIndex; j < event.currentIndex; j++) {
          this.listDatatableCategory[j] = this.listDatatableCategory[j + 1];
        }
      }
      this.listDatatableCategory[event.currentIndex] = obj;
    } else {
      for (let i = 0; i < this.listDatatableCategory.length; i++) {
        let objCat = this.listDatatableCategory[i].subCat[event.previousIndex];
        let objPrice = this.listDatatableCategory[i].price[event.previousIndex];
        let objOrgPrice = this.listDatatableCategory[i].origin_price[event.previousIndex];

        if (event.previousIndex > event.currentIndex) {
          for (let j = event.previousIndex; j > event.currentIndex; j--) {
            this.listDatatableCategory[i].subCat[j] = this.listDatatableCategory[i].subCat[j - 1];
            this.listDatatableCategory[i].price[j] = this.listDatatableCategory[i].price[j - 1];
            this.listDatatableCategory[i].origin_price[j] =
              this.listDatatableCategory[i].origin_price[j - 1];
          }
        } else {
          for (let j = event.previousIndex; j < event.currentIndex; j++) {
            this.listDatatableCategory[i].subCat[j] = this.listDatatableCategory[i].subCat[j + 1];
            this.listDatatableCategory[i].price[j] = this.listDatatableCategory[i].price[j + 1];
            this.listDatatableCategory[i].origin_price[j] =
              this.listDatatableCategory[i].origin_price[j + 1];
          }
        }

        this.listDatatableCategory[i].subCat[event.currentIndex] = objCat;
        this.listDatatableCategory[i].price[event.currentIndex] = objPrice;
        this.listDatatableCategory[i].origin_price[event.currentIndex] = objOrgPrice;
      }
    }

    for (let i = 0; i < this.listDatatableCategory.length; i++) {
      this.listDatatableCategory[i].index = i;
      for (let j = 0; j < this.listDatatableCategory[i].subCat.length; j++) {
        this.listDatatableCategory[i].subCat[j].indexSubCat = j;
        this.listDatatableCategory[i].price[j].indexPrice = j;
        this.listDatatableCategory[i].origin_price[j].indexPrice = j;
      }
    }
  }

  checkValue() {
    if (!this.all_price && !this.all_origin_price && !this.all_quantity && !this.all_SKUCode) {
      return false;
    } else {
      return true;
    }
  }
  applyAllWarehouse() {
    if (!this.all_price && !this.all_origin_price && !this.all_quantity && !this.all_SKUCode) {
      return;
    }

    for (let i = 0; i < this.listDatatableCategory.length; i++) {
      for (let j = 0; j < this.listDatatableCategory[i].subCat.length; j++) {
        for (let x = 0; x < this.listDatatableCategory[i].subCat[j].warehouse.length; x++) {
          if (this.all_quantity) {
            this.listDatatableCategory[i].subCat[j].warehouse[x].quantity = this.all_quantity;
          }
          if (this.all_SKUCode) {
            this.listDatatableCategory[i].subCat[j].warehouse[x].SKUCode = this.all_SKUCode;
          }
        }
      }

      for (let j = 0; j < this.listDatatableCategory[i].price.length; j++) {
        if (this.all_price) {
          this.listDatatableCategory[i].price[j].value = this.all_price;
        }
        for (let x = 0; x < this.listDatatableCategory[i].price[j].warehouse.length; x++) {
          if (this.all_quantity) {
            this.listDatatableCategory[i].price[j].warehouse[x].quantity = this.all_quantity;
          }
        }
      }

      for (let j = 0; j < this.listDatatableCategory[i].origin_price.length; j++) {
        if (this.all_origin_price) {
          this.listDatatableCategory[i].origin_price[j].value = this.all_origin_price;
        }
        for (let x = 0; x < this.listDatatableCategory[i].origin_price[j].warehouse.length; x++) {
          if (this.all_quantity) {
            this.listDatatableCategory[i].origin_price[j].warehouse[x].quantity = this.all_quantity;
          }
        }
      }
    }
  }

  openModalRepositoryPrivate(index, subIndex) {
    let productId = '';
    if (this.isEdit) {
      productId = this.productId;
    }

    let listWarehouse = this.listDatatableCategory[index].subCat[subIndex].warehouse;

    const dialogRef = this.dialog.open(ModalChooseRepositoryComponent, {
      width: '800px',
      data: {
        listRepository: listWarehouse,
        isEdit: this.isEdit,
        type_value_id: listWarehouse.length > 0 ? listWarehouse[0].type_value_id : '',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.event) {
        this.listDatatableCategory[index].subCat[subIndex].warehouse = result.data;
        this.listDatatableCategory[index].price[subIndex].warehouse = result.data;
        this.listDatatableCategory[index].origin_price[subIndex].warehouse = result.data;
        for (let i = 0; i < this.listDatatableCategory.length; i++) {
          let total = 0;
          for (let j = 0; j < this.listDatatableCategory[i].subCat.length; j++) {
            total +=
              this.listDatatableCategory[i].subCat[j].warehouse.length > 0
                ? this.listDatatableCategory[i].subCat[j].warehouse.length
                : 1;
          }
          this.listDatatableCategory[i].totalLine = total;
        }
        this.listIDProductRepoPrivateDelete = result.listProductRepoPrivateIdDelete;
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
        this.toastr.success('Chọn kho hàng thành công');
      }
    });
  }

  removeTag(index) {
    this.arrHashtag.splice(index, 1);
    this.arrHashtag = this.arrHashtag.slice();
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }

  change_alias(alias) {
    let str = alias;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(
      /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
      ' '
    );
    str = str.replace(/ /g, '');
    str = str.trim();
    return str;
  }

  onEnterTag(value: string) {
    // let newTag = value.replace(/ /g, '');
    let newTag = value;
    newTag = newTag.replace(/#/g, '');
    newTag = newTag.replace(/,/g, '');
    // newTag = this.change_alias(newTag);
    if (newTag !== '' && newTag !== undefined && newTag != null) {
      this.strTag = '';
      const checkTagExist = this.arrHashtag.map((val) => val).some((el) => el === newTag);
      if (checkTagExist) {
        this.toastr.warning('Hashtag đã tồn tại');
      } else {
        this.arrHashtag.push(newTag);
        this.arrHashtag = this.arrHashtag.slice();
      }
    }
  }

  cancel() {
    this.router.navigate(['admin/product-management']);
  }

  cursorFocus(elem) {
    var x = window.scrollX,
      y = window.scrollY;
    window.scrollTo(x, y);
    elem.focus();
  }

  async save(isHidden) {
    this.touched = true;
    this.infoBasicForm.value.product_category_id = this.productCategoryID;
    this.infoBasicForm.value.is_hidden = isHidden;

    if (
      this.infoBasicForm.value.name == null ||
      this.infoBasicForm.value.name == undefined ||
      this.infoBasicForm.value.name == ''
    ) {
      this.cursorFocus(document.getElementById('name-focus'));
    } else if (
      this.infoBasicForm.value.brand_id == null ||
      this.infoBasicForm.value.brand_id == undefined ||
      this.infoBasicForm.value.brand_id == ''
    ) {
      this.cursorFocus(document.getElementById('brand-focus'));
    } else if (
      this.infoBasicForm.value.product_code == null ||
      this.infoBasicForm.value.product_code == undefined ||
      this.infoBasicForm.value.product_code == ''
    ) {
      this.cursorFocus(document.getElementById('product_code_focus'));
    } else if (
      this.infoBasicForm.value.sku == null ||
      this.infoBasicForm.value.sku == undefined ||
      this.infoBasicForm.value.sku == ''
    ) {
      this.cursorFocus(document.getElementById('sku_product_focus'));
    } else if (
      this.infoBasicForm.value.summary == null ||
      this.infoBasicForm.value.summary == undefined ||
      this.infoBasicForm.value.summary == ''
    ) {
      this.cursorFocus(document.getElementById('summary-focus'));
    }

    let strHashtag = '';
    for (let i = 0; i < this.arrHashtag.length; i++) {
      if (i != this.arrHashtag.length - 1) {
        strHashtag = strHashtag + this.arrHashtag[i] + ',';
      } else {
        strHashtag = strHashtag + this.arrHashtag[i];
      }
    }
    if (strHashtag == '') {
      this.infoBasicForm.value.tags = null;
    } else {
      this.infoBasicForm.value.tags = strHashtag;
    }
    this.hasFormErrors = true;
    const controls = this.infoBasicForm.controls;
    if (this.infoBasicForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }

    if (
      this.infoBasicForm.value.product_category_id == null ||
      this.infoBasicForm.value.product_category_id == undefined ||
      this.infoBasicForm.value.product_category_id == ''
    ) {
      this.toastr.warning('Bạn chưa chọn danh mục sản phẩm');
      return;
    }

    if (
      this.isPromotion &&
      (this.infoBasicForm.value.promotion_from == null ||
        this.infoBasicForm.value.promotion_from == undefined ||
        this.infoBasicForm.value.promotion_from == '')
    ) {
      this.cursorFocus(document.getElementById('promotion_from_focus'));
      return;
    }
    if (
      this.isPromotion &&
      (this.infoBasicForm.value.promotion_deadline == null ||
        this.infoBasicForm.value.promotion_deadline == undefined ||
        this.infoBasicForm.value.promotion_deadline == '')
    ) {
      this.cursorFocus(document.getElementById('promotion_deadline_focus'));
      return;
    }

    if (this.isPromotion) {
      this.infoBasicForm.value.promotion_from = moment(
        this.infoBasicForm.value.promotion_from
      ).format('YYYY-MM-DD HH:mm');
      this.infoBasicForm.value.promotion_deadline = moment(
        this.infoBasicForm.value.promotion_deadline
      ).format('YYYY-MM-DD HH:mm');
    }

    if (this.listCategory.length == 0) {
      if (
        this.infoBasicForm.value.price == null ||
        this.infoBasicForm.value.price == undefined ||
        this.infoBasicForm.value.price == ''
      ) {
        this.cursorFocus(document.getElementById('price_focus'));
        return;
      }
      // if (this.infoBasicForm.value.origin_price == null || this.infoBasicForm.value.origin_price == undefined || this.infoBasicForm.value.origin_price == '') {
      //   this.cursorFocus(document.getElementById('origin_price_focus'));
      //   return;
      // }
      this.infoBasicForm.value.price = Number(
        this.infoBasicForm.value.price.toString().replace(/[,]+/g, '')
      );
      this.infoBasicForm.value.origin_price = this.infoBasicForm.value.origin_price
        ? Number(this.infoBasicForm.value.origin_price.toString().replace(/[,]+/g, ''))
        : null;
    } else {
      this.infoBasicForm.value.price = 0;
      this.infoBasicForm.value.origin_price = 0;
    }

    if (this.productData.extend_images.length == 0) {
      this.toastr.warning('Chọn ít nhất 1 ảnh sản phẩm');
      return;
    }

    let count = 0;
    if (this.listCategory.length == 0) {
      for (let i = 0; i < this.listWarehouse.length; i++) {
        count += this.listWarehouse[i].quantity;
      }
    }
    this.infoBasicForm.value.quantity = count;

    if (this.infoBasicForm.value.shipping_fee || this.infoBasicForm.value.shipping_fee === 0) {
      this.infoBasicForm.value.shipping_fee = Number(
        this.infoBasicForm.value.shipping_fee.toString().replace(/[,]+/g, '')
      );
    }

    const formValue = this.infoBasicForm.value;

	const createPayload = {
	...formValue,

	dimension_length: this.buildDimension(
		formValue.dimension_length,
		this.dimensionLengthUnit
	),

	dimension_width: this.buildDimension(
		formValue.dimension_width,
		this.dimensionWidthUnit
	),

	dimension_height: this.buildDimension(
		formValue.dimension_height,
		this.dimensionHeightUnit
	),

	weight:
		formValue.weight === null ||
		formValue.weight === undefined ||
		formValue.weight === ''
		? null
		: Number(formValue.weight),

	is_new_arrival:
		this.infoBasicForm.get('is_new_arrival').value === true
	};

    this.productService.apiProductsPost(createPayload).subscribe(async (res) => {
      if (res.success) {
        for (let i = 0; i < this.productData.extend_images.length; i++) {
          this.productService
            .apiProductsProductIDImagesPut(
              res.data.id,
              this.productData.extend_images[i].file,
              i,
              this.productData.extend_images[i].summary
            )
            .subscribe((resUploadImg) => {});
        }

        if (this.listCategory.length == 0) {
          for (let i = 0; i < this.listWarehouse.length; i++) {
            let obj = {
              product_id: res.data.id,
              repo_id: this.listWarehouse[i].id,
              quantity: this.listWarehouse[i].quantity,
              sku: this.listWarehouse[i].SKUCode,
              leadtime: this.listWarehouse[i].leadtime,
            };
            this.productRepoService.apiProductRepositoriesPost(obj).subscribe((x) => {});
          }
        }

        let arrIDtype = [];

        let sort_order = 0;
        for (let i = 0; i < this.listCategory.length; i++) {
          for (let j = 0; j < this.listCategory[i].listCat.length; j++) {
            if (this.listCategory[i].listCat[j].nameSubCat) {
              let obj = {
                product_id: res.data.id,
                name: this.listCategory[i].listCat[j].nameSubCat,
                group_name: this.listCategory[i].name,
                sort_order: sort_order,
              };
              sort_order++;
              await this.productTypeService
                .apiProductTypesPost(obj)
                .toPromise()
                .then((resProductType) => {
                  if (resProductType.success) {
                    if (i == 0) {
                      arrIDtype.push({
                        parentId: resProductType.data.id,
                        childId: [],
                      });
                    } else {
                      for (let x = 0; x < arrIDtype.length; x++) {
                        arrIDtype[x].childId.push(resProductType.data.id);
                      }
                    }
                  }
                });
            }
          }
        }

        await this.productTypeValueService
          .apiProductIdProductTypesValuesGet(res.data.id)
          .toPromise()
          .then((resProductTypeValue) => {
            if (resProductTypeValue.success) {
              let arrIdTypeValue = [];
              for (let i = 0; i < arrIDtype.length; i++) {
                for (let j = 0; j < arrIDtype[i].childId.length; j++) {
                  arrIdTypeValue.push({
                    i: i,
                    j: j,
                    type_id: [arrIDtype[i].parentId, arrIDtype[i].childId[j]].sort(),
                  });
                }

                if (arrIDtype[i].childId.length == 0) {
                  arrIdTypeValue.push({
                    i: i,
                    j: 0,
                    type_id: [arrIDtype[i].parentId].sort(),
                  });
                }
              }

              let resulTypeValue = resProductTypeValue.data.collection;
              for (let i = 0; i < resulTypeValue.length; i++) {
                resulTypeValue[i].type_id = resulTypeValue[i].type_id.sort();
                for (let j = 0; j < arrIdTypeValue.length; j++) {
                  if (
                    JSON.stringify(resulTypeValue[i].type_id) ==
                    JSON.stringify(arrIdTypeValue[j].type_id)
                  ) {
                    resulTypeValue[i].price =
                      this.listDatatableCategory[arrIdTypeValue[j].i].price[
                        arrIdTypeValue[j].j
                      ].value;
                    resulTypeValue[i].origin_price =
                      this.listDatatableCategory[arrIdTypeValue[j].i].origin_price[
                        arrIdTypeValue[j].j
                      ].value;
                    let quantity = 0;
                    for (
                      let k = 0;
                      k <
                      this.listDatatableCategory[arrIdTypeValue[j].i].subCat[arrIdTypeValue[j].j]
                        .warehouse.length;
                      k++
                    ) {
                      quantity +=
                        this.listDatatableCategory[arrIdTypeValue[j].i].subCat[arrIdTypeValue[j].j]
                          .warehouse[k].quantity;
                    }
                    resulTypeValue[i].quantity = quantity;

                    let objUpdate = {
                      price: resulTypeValue[i].price
                        ? Number(resulTypeValue[i].price.toString().replace(/[,]+/g, ''))
                        : 0,
                      origin_price: resulTypeValue[i].origin_price
                        ? Number(resulTypeValue[i].origin_price.toString().replace(/[,]+/g, ''))
                        : 0,
                      quantity: resulTypeValue[i].quantity,
                    };
                    this.productTypeValueService
                      .apiProductTypesValuesIdPut(resulTypeValue[i].id, objUpdate)
                      .subscribe((x) => {});

                    resulTypeValue[i].listWarehouse =
                      this.listDatatableCategory[arrIdTypeValue[j].i].subCat[
                        arrIdTypeValue[j].j
                      ].warehouse;
                  }
                }
              }

              for (let i = 0; i < resulTypeValue.length; i++) {
                for (let j = 0; j < resulTypeValue[i].listWarehouse.length; j++) {
                  let obj = {
                    type_value_id: resulTypeValue[i].id,
                    repo_id: resulTypeValue[i].listWarehouse[j].id,
                    quantity: resulTypeValue[i].listWarehouse[j].quantity,
                    sku: resulTypeValue[i].listWarehouse[j].SKUCode,
                    leadtime: resulTypeValue[i].listWarehouse[j].leadtime,
                  };
                  this.productRepoTypeValueService
                    .apiProductRepoTypeValuesPost(obj)
                    .subscribe((x) => {});
                }
              }
              this.toastr.success('Thêm mới sản phẩm thành công');
              this.router.navigate(['admin/product-management']);
            } else {
              this.toastr.error(res.message, 'Thêm mới không thành công');
            }
          });
      } else {
        this.toastr.error(res.message, 'Thêm mới không thành công');
      }
    });
  }

  async update() {
    this.touched = true;
    this.infoBasicForm.value.product_category_id = this.productCategoryID;

    if (
      this.infoBasicForm.value.name == null ||
      this.infoBasicForm.value.name == undefined ||
      this.infoBasicForm.value.name == ''
    ) {
      this.cursorFocus(document.getElementById('name-focus'));
    } else if (
      this.infoBasicForm.value.brand_id == null ||
      this.infoBasicForm.value.brand_id == undefined ||
      this.infoBasicForm.value.brand_id == ''
    ) {
      this.cursorFocus(document.getElementById('brand-focus'));
    } else if (
      this.infoBasicForm.value.product_code == null ||
      this.infoBasicForm.value.product_code == undefined ||
      this.infoBasicForm.value.product_code == ''
    ) {
      this.cursorFocus(document.getElementById('product_code_focus'));
    } else if (
      this.infoBasicForm.value.sku == null ||
      this.infoBasicForm.value.sku == undefined ||
      this.infoBasicForm.value.sku == ''
    ) {
      this.cursorFocus(document.getElementById('sku_product_focus'));
    } else if (
      this.infoBasicForm.value.summary == null ||
      this.infoBasicForm.value.summary == undefined ||
      this.infoBasicForm.value.summary == ''
    ) {
      this.cursorFocus(document.getElementById('summary-focus'));
    }

    let strHashtag = '';
    for (let i = 0; i < this.arrHashtag.length; i++) {
      if (i != this.arrHashtag.length - 1) {
        strHashtag = strHashtag + this.arrHashtag[i] + ',';
      } else {
        strHashtag = strHashtag + this.arrHashtag[i];
      }
    }
    if (strHashtag == '') {
      this.infoBasicForm.value.tags = null;
    } else {
      this.infoBasicForm.value.tags = strHashtag;
    }
    this.hasFormErrors = true;
    const controls = this.infoBasicForm.controls;

    if (this.infoBasicForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    if (
      this.infoBasicForm.value.product_category_id == null ||
      this.infoBasicForm.value.product_category_id == undefined ||
      this.infoBasicForm.value.product_category_id == ''
    ) {
      this.toastr.warning('Bạn chưa chọn danh mục sản phẩm');
      return;
    }

    if (
      this.isPromotion &&
      (this.infoBasicForm.value.promotion_from == null ||
        this.infoBasicForm.value.promotion_from == undefined ||
        this.infoBasicForm.value.promotion_from == '')
    ) {
      this.cursorFocus(document.getElementById('promotion_from_focus'));
      return;
    }
    if (
      this.isPromotion &&
      (this.infoBasicForm.value.promotion_deadline == null ||
        this.infoBasicForm.value.promotion_deadline == undefined ||
        this.infoBasicForm.value.promotion_deadline == '')
    ) {
      this.cursorFocus(document.getElementById('promotion_deadline_focus'));
      return;
    }

    if (this.isPromotion) {
      this.infoBasicForm.value.promotion_from = moment(
        this.infoBasicForm.value.promotion_from
      ).format('YYYY-MM-DD HH:mm');
      this.infoBasicForm.value.promotion_deadline = moment(
        this.infoBasicForm.value.promotion_deadline
      ).format('YYYY-MM-DD HH:mm');
    }

    if (this.listCategory.length == 0) {
      if (
        this.infoBasicForm.value.price == null ||
        this.infoBasicForm.value.price == undefined ||
        this.infoBasicForm.value.price == ''
      ) {
        this.cursorFocus(document.getElementById('price_focus'));
        return;
      }
      // if (this.infoBasicForm.value.origin_price == null || this.infoBasicForm.value.origin_price == undefined || this.infoBasicForm.value.origin_price == '') {
      //   this.cursorFocus(document.getElementById('origin_price_focus'));
      //   return;
      // }
      this.infoBasicForm.value.price = Number(
        this.infoBasicForm.value.price.toString().replace(/[,]+/g, '')
      );
      this.infoBasicForm.value.origin_price = this.infoBasicForm.value.origin_price
        ? Number(this.infoBasicForm.value.origin_price.toString().replace(/[,]+/g, ''))
        : null;
    } else {
      this.infoBasicForm.value.price = 0;
      this.infoBasicForm.value.origin_price = 0;
    }

    if (this.productData.extend_images.length == 0) {
      this.toastr.warning('Chọn ít nhất 1 ảnh sản phẩm');
      return;
    }

    for (let i = 0; i < this.listIDImgDelete.length; i++) {
      this.productService.apiProductImageIDDelete(this.listIDImgDelete[i]).subscribe((x) => {});
    }

    for (let i = 0; i < this.productData.extend_images.length; i++) {
      if (this.productData.extend_images[i].is_new) {
        let sortOrder = this.productData.extend_images[i].is_edit
          ? this.productData.extend_images[i].sort_order
          : this.sort_order_next;
        await this.productService
          .apiProductsProductIDImagesPut(
            this.productId,
            this.productData.extend_images[i].file,
            sortOrder,
            this.productData.extend_images[i].summary
          )
          .toPromise()
          .then((resUploadImg) => {
            if (resUploadImg.success) {
              this.productData.extend_images[i].physical_path =
                environment.backendhost + resUploadImg.data.physical_path;
            }
          });
        if (!this.productData.extend_images[i].is_edit) {
          this.sort_order_next++;
        }
      }
    }

    // if(!this.productData.extend_images[0].is_new){
    this.infoBasicForm.value.default_image =
      this.productData.extend_images[0].physical_path.replace(environment.backendhost, '');
    // }

    let count = 0;
    if (this.listCategory.length == 0) {
      for (let i = 0; i < this.listWarehouse.length; i++) {
        count += this.listWarehouse[i].quantity;
      }
    }
    this.infoBasicForm.value.quantity = count;

    const formValue = this.infoBasicForm.value;

	const payload = {
	...formValue,

	dimension_length: this.buildDimension(
		formValue.dimension_length,
		this.dimensionLengthUnit
	),

	dimension_width: this.buildDimension(
		formValue.dimension_width,
		this.dimensionWidthUnit
	),

	dimension_height: this.buildDimension(
		formValue.dimension_height,
		this.dimensionHeightUnit
	),

	weight:
		formValue.weight === null ||
		formValue.weight === undefined ||
		formValue.weight === ''
		? null
		: Number(formValue.weight),

	is_new_arrival:
		this.infoBasicForm.get('is_new_arrival').value === true
	};


    if (payload.shipping_fee || payload.shipping_fee === 0) {
      payload.shipping_fee = Number(String(payload.shipping_fee).replace(/[,]+/g, ''));
    }

    this.productService.apiProductsIdPut(this.productId, payload).subscribe(async (res) => {
        if (res.success) {
          for (let i = 0; i < this.listIDSubCatDelete.length; i++) {
            this.productTypeService
              .apiProductTypesIdDelete(this.listIDSubCatDelete[i])
              .subscribe((x) => {});
          }

          if (this.listCategory.length == 0) {
            for (let i = 0; i < this.listIDProductRepoDelete.length; i++) {
              this.productRepoService
                .apiProductRepositoriesIdDelete(this.listIDProductRepoDelete[i])
                .subscribe((x) => {});
            }
            for (let i = 0; i < this.listWarehouse.length; i++) {
              let obj = {
                product_id: this.productId,
                repo_id: this.listWarehouse[i].repo_id,
                quantity: this.listWarehouse[i].quantity,
                sku: this.listWarehouse[i].SKUCode,
                leadtime: this.listWarehouse[i].leadtime,
              };

              if (this.listWarehouse[i].is_new) {
                this.productRepoService.apiProductRepositoriesPost(obj).subscribe((x) => {});
              } else {
                this.productRepoService
                  .apiProductRepositoriesIdPut(this.listWarehouse[i].id_delete, obj)
                  .subscribe((x) => {});
              }
            }
          } else {
            for (let i = 0; i < this.listWarehouse.length; i++) {
              if (!this.listWarehouse[i].is_new) {
                this.productRepoService
                  .apiProductRepositoriesIdDelete(this.listWarehouse[i].id_delete)
                  .subscribe((x) => {});
              }
            }

            for (let i = 0; i < this.listIDProductRepoPrivateDelete.length; i++) {
              this.productRepoTypeValueService
                .apiProductRepoTypeValuesIdDelete(this.listIDProductRepoPrivateDelete[i])
                .subscribe((x) => {});
            }

            let sort_order = 0;
            let listIdNew = [];
            for (let i = 0; i < this.listCategory.length; i++) {
              for (let j = 0; j < this.listCategory[i].listCat.length; j++) {
                if (this.listCategory[i].listCat[j].nameSubCat) {
                  let obj = {
                    product_id: this.productId,
                    name: this.listCategory[i].listCat[j].nameSubCat,
                    group_name: this.listCategory[i].name,
                    sort_order: sort_order,
                  };
                  sort_order++;

                  if (this.listCategory[i].listCat[j].is_new) {
                    await this.productTypeService
                      .apiProductTypesPost(obj)
                      .toPromise()
                      .then((r) => {
                        if (r.success) {
                          listIdNew.push({
                            id: r.data.id,
                            i: i,
                            j: j,
                          });
                          if (i == 0) {
                            this.listDatatableCategory[j].id = r.data.id;
                          } else {
                            for (let k = 0; k < this.listDatatableCategory.length; k++) {
                              this.listDatatableCategory[k].subCat[j].id = r.data.id;
                            }
                          }
                        }
                      });
                  } else {
                    await this.productTypeService
                      .apiProductTypesIdPut(this.listCategory[i].listCat[j].id, obj)
                      .toPromise()
                      .then((x) => {});
                  }
                }
              }
            }

            await this.productTypeValueService
              .apiProductIdProductTypesValuesGet(this.productId)
              .toPromise()
              .then((resTypeValue) => {
                if (resTypeValue.success) {
                  for (let i = 0; i < resTypeValue.data.collection.length; i++) {
                    resTypeValue.data.collection[i].type_id =
                      resTypeValue.data.collection[i].type_id.sort();

                    for (let j = 0; j < this.listDatatableCategory.length; j++) {
                      for (let k = 0; k < this.listDatatableCategory[j].subCat.length; k++) {
                        // let arr = [this.listDatatableCategory[j].id, this.listDatatableCategory[j].subCat[k].id].sort()
                        let arr;
                        if (this.listDatatableCategory[j].subCat[k].id) {
                          arr = [
                            this.listDatatableCategory[j].id,
                            this.listDatatableCategory[j].subCat[k].id,
                          ].sort();
                        } else {
                          arr = [this.listDatatableCategory[j].id].sort();
                        }

                        if (
                          JSON.stringify(resTypeValue.data.collection[i].type_id) ==
                          JSON.stringify(arr)
                        ) {
                          let quantity = 0;
                          for (
                            let t = 0;
                            t < this.listDatatableCategory[j].subCat[k].warehouse.length;
                            t++
                          ) {
                            quantity +=
                              this.listDatatableCategory[j].subCat[k].warehouse[t].quantity;
                          }

                          let objUpdate = {
                            price: this.listDatatableCategory[j].price[k].value
                              ? Number(
                                  this.listDatatableCategory[j].price[k].value
                                    .toString()
                                    .replace(/[,]+/g, '')
                                )
                              : 0,
                            origin_price: this.listDatatableCategory[j].origin_price[k].value
                              ? Number(
                                  this.listDatatableCategory[j].origin_price[k].value
                                    .toString()
                                    .replace(/[,]+/g, '')
                                )
                              : 0,
                            quantity: quantity,
                          };

                          // let objUpdate = {
                          //   price: this.listDatatableCategory[j].price[k].value,
                          //   origin_price: this.listDatatableCategory[j].origin_price[k].value,
                          //   quantity: quantity
                          // }
                          this.productTypeValueService
                            .apiProductTypesValuesIdPut(
                              resTypeValue.data.collection[i].id,
                              objUpdate
                            )
                            .subscribe((x) => {});
                          for (
                            let t = 0;
                            t < this.listDatatableCategory[j].subCat[k].warehouse.length;
                            t++
                          ) {
                            let objRepoTypeValue = {
                              type_value_id: resTypeValue.data.collection[i].id,
                              repo_id: this.listDatatableCategory[j].subCat[k].warehouse[t].id,
                              quantity:
                                this.listDatatableCategory[j].subCat[k].warehouse[t].quantity,
                              sku: this.listDatatableCategory[j].subCat[k].warehouse[t].SKUCode,
                              leadtime: this.listDatatableCategory[j].subCat[k].warehouse[t].leadtime,
                            };
                            if (this.listDatatableCategory[j].subCat[k].warehouse[t].is_new) {
                              this.productRepoTypeValueService
                                .apiProductRepoTypeValuesPost(objRepoTypeValue)
                                .subscribe((x) => {});
                            } else {
                              this.productRepoTypeValueService
                                .apiProductRepoTypeValuesIdPut(
                                  this.listDatatableCategory[j].subCat[k].warehouse[t].id_update,
                                  objRepoTypeValue
                                )
                                .subscribe((x) => {});
                            }
                          }
                        }
                      }
                    }
                  }
                }
              });
          }
          this.toastr.success('Cập nhật thông tin sản phẩm thành công');
          this.router.navigate(['admin/product-management']);
        } else {
          this.toastr.error(res.message, 'Cập nhật thông tin sản phẩm không thành công');
        }
      });
  }

  checkPromotion(event) {
    this.isPromotion = event.checked;
  }

  preview() {
    let link =
      '/product/' +
      this.productId +
      '/' +
      UtilService.slugify(this.productName) +
      '/details/preview';
    window.open(link, '_blank');
  }

  productShowHidden() {
    this.infoBasicForm.patchValue({
      is_hidden: !this.infoBasicForm.value.is_hidden,
    });
  }

  /**
   * Setup SEO for admin page (prevent indexing and set appropriate title)
   */
  private setupAdminSEO(): void {
    // Check route to set appropriate title
    const currentRoute = this.router.url;
    let title = this.pageTitle;

    if (currentRoute.includes('/create')) {
      title = 'Tạo sản phẩm mới - Admin BimParts';
    } else if (currentRoute.includes('/edit')) {
      // If productId exists, add to title
      const productId = this.route.snapshot.paramMap.get('productId');
      title = productId
        ? `Chỉnh sửa sản phẩm #${productId} - Admin BimParts`
        : 'Chỉnh sửa sản phẩm - Admin BimParts';
    }

    // Set page title
    this.titleService.setTitle(title);

    // Prevent search engines from indexing admin pages
    this.metaService.updateTag({
      name: 'robots',
      content: 'noindex, nofollow, noarchive, nosnippet',
    });

    // Set description for admin
    this.metaService.updateTag({
      name: 'description',
      content: 'Trang quản lý sản phẩm dành cho admin BimParts',
    });

    // Remove Open Graph tags (not needed for admin pages)
    this.metaService.removeTag('property="og:title"');
    this.metaService.removeTag('property="og:description"');
    this.metaService.removeTag('property="og:image"');

    // Set viewport for responsive admin
    this.metaService.updateTag({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0',
    });
  }

  private buildDimension(
	value: string | number,
	unit: string
	): string | null {
	if (
		value === null ||
		value === undefined ||
		value === ''
	) {
		return null;
	}

	return `${value}${unit}`;
	}

	private parseDimension(
	dimension: string | number
	): { value: number | null; unit: string } {
	if (
		dimension === null ||
		dimension === undefined ||
		dimension === ''
	) {
		return {
		value: null,
		unit: 'cm'
		};
	}

	const dimensionValue = String(dimension).trim();

	const result = dimensionValue.match(
		/^(\d+(?:[.,]\d+)?)\s*(mm|cm|m|inch)?$/i
	);

	if (!result) {
		return {
		value: null,
		unit: 'cm'
		};
	}

	return {
		value: Number(result[1].replace(',', '.')),
		unit: result[2] ? result[2].toLowerCase() : 'cm'
	};
	}
}
